
/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ["admin", "editor"];
  return valid_map.indexOf(str.trim()) >= 0;
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return reg.test(url);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/;
  return reg.test(str);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/;
  return reg.test(str);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/;
  return reg.test(str);
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  // eslint-disable-next-line no-useless-escape
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(email);
}
/**
 * @param {string} 货币数字
 *
 * @returns {Boolean}
 */
export function validcurrency(number) {
  const reg = /^[0-9]+([.][0-9]{1,2})?$/;
  return reg.test(number);
}

/**
 * @param {string} 2020/05/21  Format date
 * 2020/05/21格式日期
 * @returns {Boolean}
 */
export function validFormatdate(date) {
  const reg = /^[0-9]{4}\/[0-9]{1,2}\/[0-9]{1,2}$/;
  return reg.test(date);
}

/**
 * @param {string} password
 * @returns {Boolean}
 */
export function validPassword(password) {
  const reg =
    /^.*[\d]+.*$/.test(password) &&
    /^.*[a-zA-Z]+.*$/.test(password) &&
    /^.{6,20}$/.test(password);
  return reg;
}

/**
 * @param {string} tel
 * 手机号
 * @returns {Boolean}
 */
export function validPhone(tel) {
  const reg = /^1[3456789]\d{9}$/;
  return reg.test(tel);
}
/**
 * @param {string} Landline
 * 座机
 * @returns {Boolean}
 */
export function validLandline(tel) {
  const reg = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/;
  return reg.test(tel);
}
/**
 * @param {string} Postal Code
 * 邮政编码
 * @returns {Boolean}
 */
export function validPostalCode(Code) {
  const reg = /[1-9][0-9]{5}/;
  return reg.test(Code);
}
/**
 * @param {string} Remove extra space
 * 删除多余空格
 * @returns {Boolean}
 */
export function validRemoveExtra(Code) {
  const reg = /\s/g;
  var result = Code.replace(reg, "");
  return result;
}
/**
 * @param {string} Remove leading and trailing spaces
 * 删除首尾空格
 * @returns {string}
 */
export function validRemoveSpaces(Code) {
  var reg = /^\s+/; // 强制首
  var result = Code.replace(reg, "");
  reg = /\s+$/; // 强制尾
  result = Code.replace(reg, "");
  return result;
}
/**
 * 计算字符长度
 * @param {*} value
 */
export function validateTextLength(value) {
  // 中文、中文标点、全角字符按1长度，英文、英文符号、数字按0.5长度计算
  const cnReg = /([\u4e00-\u9fa5]|[\u3000-\u303F]|[\uFF00-\uFF60])/g;
  const mat = value.match(cnReg);
  let length;
  if (mat) {
    length = mat.length + (value.length - mat.length) * 0.5;
    return length;
  } else {
    return value.length * 0.5;
  }
}
/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === "string" || str instanceof String) {
    return true;
  }
  return false;
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === "undefined") {
    return Object.prototype.toString.call(arg) === "[object Array]";
  }
  return Array.isArray(arg);
}
/**
 * 判断字符是否为空
 * @param {*} obj
 */
export function isEmpty(obj) {
  return typeof obj === "undefined" || obj === null || obj === "";
}
